import * as React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
const StyledInterviewTypeImage = styled.img`
  width: 100%;
  max-width: 100px;
`;

interface IInterviewTypeImage
  extends React.ImgHTMLAttributes<HTMLImageElement> {}

export const InterviewTypeImage: React.FC<IInterviewTypeImage> = (props) => {
  return (
    <StyledWrapper>
      <StyledInterviewTypeImage {...props} />
    </StyledWrapper>
  );
};
